import { message } from 'antd';

export const hi = 'hi';

export const beforeUpload = file => {
  const isImage = file.type.indexOf('image/') === 0;
  if (!isImage) {
    message.error('You can only upload image file!');
  }

  // You can remove this validation if you want
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    message.error('Image must smaller than 5MB!');
  }
  return isImage && isLt5M;
};
